import React, { useEffect, useState } from "react";
import { GitMerge, X } from "lucide-react";
import { api } from "../../api";
import { money } from "../../lib/format";

export const OrgMergeDialog = ({ source, candidates, onClose, onApplied }) => {
  const [survivorId, setSurvivorId] = useState("");
  const [preview, setPreview] = useState(null);
  const [resolutions, setResolutions] = useState({});
  const [confirmation, setConfirmation] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => { setPreview(null); setResolutions({}); setError(""); }, [survivorId]);
  const getPreview = async () => {
    if (!survivorId) return;
    setBusy(true); setError("");
    try {
      const response = await api.get("/organization/merge-preview", { params: { source_id: source.id, survivor_id: survivorId } });
      setPreview(response.data);
    } catch (requestError) { setError(requestError.response?.data?.detail || "Önizleme alınamadı"); }
    finally { setBusy(false); }
  };
  const apply = async () => {
    setBusy(true); setError("");
    try {
      await api.post("/organization/merge", { source_id: source.id, survivor_id: survivorId,
        preview_token: preview.preview_token, confirmation_name: confirmation,
        reason, conflict_resolutions: resolutions });
      onApplied("Birleştirme uygulandı; işlem geçmişinden geri alınabilir.");
    } catch (requestError) { setError(requestError.response?.data?.detail || "Birleştirilemedi"); }
    finally { setBusy(false); }
  };
  const conflictsDone = preview && preview.target_conflicts.every((conflict) => resolutions[conflict.key]);
  const canApply = conflictsDone && confirmation === source.node_name && reason.trim().length >= 3;
  return <div className="modal-backdrop" data-testid="org-merge-preview-modal" onMouseDown={onClose}>
    <div className="modal org-merge-modal" onMouseDown={(event) => event.stopPropagation()}>
      <div className="modal-head"><div><span className="eyebrow">KULLANICI KONTROLLÜ BİRLEŞTİRME</span><strong>{source.node_name}</strong></div>
        <button className="icon-button" data-testid="org-merge-close-btn" onClick={onClose}><X size={16}/></button></div>
      <div className="org-impact-content">
        <label>Kalacak kayıt<select data-testid="org-merge-survivor-select" value={survivorId} onChange={(event) => setSurvivorId(event.target.value)}>
          <option value="">Seçin…</option>{candidates.map((node) => <option key={node.id} value={node.id}>{node.path || node.node_name}</option>)}
        </select></label>
        <button className="outline-button" data-testid="org-merge-preview-btn" disabled={!survivorId || busy} onClick={getPreview}>Etkiyi Hesapla</button>
        {error && <div className="error" data-testid="org-merge-error">{error}</div>}
        {preview && <>
          <div className="org-impact-grid" data-testid="org-merge-impact-counts">
            <span>Alt kayıt<strong>{preview.impact.descendant_count}</strong></span><span>Hedef satırı<strong>{preview.impact.target_rows}</strong></span>
            <span>Üretim<strong>{preview.impact.production.rows}</strong></span><span>Alias<strong>{preview.impact.aliases}</strong></span>
            <span>Kullanıcı<strong>{preview.impact.users}</strong></span>
          </div>
          <div className="org-merge-paths"><del>{preview.source.path}</del><strong>{preview.survivor.path}</strong></div>
          <section className="org-conflicts" data-testid="org-merge-target-conflicts">
            <h3>Hedef çakışmaları · {preview.target_conflicts.length}</h3>
            {!preview.target_conflicts.length && <p className="muted">Aynı yıl/ay için hedef çakışması yok.</p>}
            {preview.target_conflicts.map((conflict) => <div key={conflict.key}>
              <b>{conflict.key}</b><label><input type="radio" name={conflict.key} data-testid={`merge-conflict-source-${conflict.key}`}
                checked={resolutions[conflict.key] === "KEEP_SOURCE"} onChange={() => setResolutions({ ...resolutions, [conflict.key]: "KEEP_SOURCE" })}/>
                Kaynağı koru · {money(conflict.source_value, false)}</label>
              <label><input type="radio" name={conflict.key} data-testid={`merge-conflict-survivor-${conflict.key}`}
                checked={resolutions[conflict.key] === "KEEP_SURVIVOR"} onChange={() => setResolutions({ ...resolutions, [conflict.key]: "KEEP_SURVIVOR" })}/>
                Kalacak kaydı koru · {money(conflict.survivor_value, false)}</label>
            </div>)}
          </section>
          <label>Gerekçe<textarea data-testid="org-merge-reason-input" rows={2} value={reason} onChange={(event) => setReason(event.target.value)}/></label>
          <label>Onay için <b>{source.node_name}</b> yazın<input data-testid="org-merge-confirmation-input" value={confirmation} onChange={(event) => setConfirmation(event.target.value)}/></label>
        </>}
      </div>
      <div className="modal-foot"><button className="outline-button" data-testid="org-merge-cancel-btn" onClick={onClose}>Vazgeç</button>
        <button className="primary-button" data-testid="merge-confirm-submit-btn" disabled={!canApply || busy} onClick={apply}><GitMerge size={14}/>{busy ? "İşleniyor…" : "Birleştir"}</button></div>
    </div>
  </div>;
};